import { render, staticRenderFns } from "./uncollapsed_assignee_list.vue?vue&type=template&id=3057c42d"
import script from "./uncollapsed_assignee_list.vue?vue&type=script&lang=js"
export * from "./uncollapsed_assignee_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports